export default {
  SET_USER_LOADING: 'SET_USER_LOADING',
  CHECK_USER_REQUEST: 'CHECK_USER_REQUEST',
  SIGN_OUT_REQUEST: 'SIGN_OUT_REQUEST',
  SIGN_IN_REQUEST: 'SIGN_IN_REQUEST',
  GET_USER_REQUEST: 'GET_USER_REQUEST'
}
